import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const generateFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[]
): ModuleFields[] => {
  return languages.flatMap((lang) => {
    const fields: ModuleFields[] = [];
    if (lang.parseField === "field_content_english") {
      fields.push({
        fieldName: `Image`,
        fieldValue: `${basePath}.banner`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "image",
        name: `${lang.parseField}.${basePath}.banner`,
        formType: "file",
        usedFileType: "image/*",
        label: `Image`,
        placeholder: `Select Image`,
        validation: lang.parseField === "field_content_english" ? { required: `Image is required` } : undefined,
      });
    }
    return fields;
  });
};

export const generateFieldsFeatures = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[],
  idx: any
): ModuleFields[] => {
  return languages.flatMap((lang) => {
    const fields: ModuleFields[] = [];
    if (lang.parseField === "field_content_english") {
      fields.push({
        fieldName: `Image`,
        fieldValue: `${basePath}.cardData[${idx}].image`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "image",
        name: `${lang.parseField}.${basePath}.cardData[${idx}].image`,
        formType: "file",
        usedFileType: "image/*",
        label: `Image`,
        placeholder: `Select Image`,
        validation: lang.parseField === "field_content_english" ? { required: `Image is required` } : undefined,
      });
    }
    fields.push(
      {
        fieldName: `Title (${lang.code})`,
        fieldValue: `${basePath}.cardData[${idx}].title`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.cardData[${idx}].title`,
        formType: "input",
        label: `Title (${lang.code})`,
        placeholder: `Enter Title ${lang.code}`,
        validation:
          lang.parseField === "field_content_english" ? { required: `Title ${lang.code} is required` } : undefined,
      },
      {
        fieldName: `Link (${lang.code})`,
        fieldValue: `${basePath}.cardData[${idx}].link`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "pdf",
        name: `${lang.parseField}.${basePath}.cardData[${idx}].link`,
        formType: "file",
        label: `Link (${lang.code})`,
        placeholder: `Enter Link ${lang.code}`,
        validation:
          lang.parseField === "field_content_english" ? { required: `Link ${lang.code} is required` } : undefined,
      }
    );
    return fields;
  });
};

export const languages = [
  { code: "EN", label: "English", parseField: "field_content_english" },
  { code: "MS", label: "Malay", parseField: "field_content_malay" },
  { code: "ZH", label: "Mandarin", parseField: "field_content_mandarin" },
];

let url = `/api/page-content/all-fields?pageName=sustainability/reports`;

export let getData: { [key in ModuleConfig]: ModuleFields[] } | null = null;

const fetchProfileData = async (): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    const res = await corporateCMSApi.get(url);
    const profileData = res.data;

    if (!profileData?.[0]?.field_content_english?.data) {
      return null;
    }

    const dataFields = generateFields("data", languages);
    const dataFieldsFeatures =
      profileData?.[0]?.field_content_english?.data?.cardData?.map((item: any, index: number) =>
        generateFieldsFeatures("data", languages, index)
      ) || [];
    console.log("dataFieldsFeaturesNow", dataFieldsFeatures);

    return {
      reportsMainContent: dataFields as ModuleFields[],
      reportsFeatures: dataFieldsFeatures as ModuleFields[],
    };
  } catch (error) {
    console.error("Error fetching profile data:", error);
    return null;
  }
};

export const getReportsDrillDownData = async () => {
  if (!getData) {
    getData = await fetchProfileData();
  }
  return getData;
};
